import React, { FC, Fragment } from 'react'

import { Mismatches } from 'api/search/search.types'
import {
  MismatchesList,
  MismatchesItem,
} from 'components/page/Search/Search.styled'
import { capitalizeFirstLetter } from 'functions/index'
import { useShallowEqualSelector } from 'hooks/useShallowEqualSelector'

// TODO: capitalizeFirstLetter - так как нормально не работает для inline элементов ::first-letter, то приходится
export const SearchListMismatches: FC<{ mismatches: Mismatches }> = ({
  mismatches,
}) => {
  const { authorized } = useShallowEqualSelector(
    ({ authorizationReducer: { authorized } }) => ({
      authorized,
    })
  )

  if (authorized && mismatches && mismatches.interests.length > 0) {
    return (
      <MismatchesList>
        {mismatches.interests.map(({ id, text }, index) => {
          if (index === 0) {
            return (
              <Fragment key={id}>
                <MismatchesItem>{capitalizeFirstLetter(text)}</MismatchesItem>
                {index !== mismatches.interests.length - 1 && (
                  <Fragment>, </Fragment>
                )}
              </Fragment>
            )
          }
          return (
            <Fragment key={id}>
              <MismatchesItem>{text}</MismatchesItem>
              {index !== mismatches.interests.length - 1 && (
                <Fragment>, </Fragment>
              )}
            </Fragment>
          )
        })}
      </MismatchesList>
    )
  }
  return null
}
